import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { searchContext } from '@/context/Context';
import type { SearchContext } from '@/types';
import { useSearchTabNavigation } from '@/hooks/search/useSearchTabNavigation';

export function useSearchTabsSync() {
  const location = useLocation();
  const { syncFromLocation, flushActiveSearch } = useSearchTabNavigation();
  const { searchItems } = searchContext() as unknown as SearchContext;

  const searchKey = location.search;
  const itemsKey = useMemo(() => (searchItems ?? []).map((item: any) => item?.id).join('-'), [searchItems]);

  useEffect(() => {
    if (!['/search', '/examples'].includes(location.pathname)) return;
    syncFromLocation(window.location.search || searchKey, searchItems);
  }, [location.pathname, searchKey, itemsKey, searchItems, syncFromLocation]);

  useEffect(() => {
    const flush = () => flushActiveSearch(window.location.search);
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') flush();
    };
    window.addEventListener('pagehide', flush);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('pagehide', flush);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [flushActiveSearch]);
}
